import client from "../Client/HttpClient";
import { IAccessDutyListModel } from "@/interfaces/modules";
const ApiPath = "SystemAccessDutytList";

export default {
  GetAccessDutytListDuties: (): Promise<IAccessDutyListModel[]> => client.get(`${ApiPath}`),
  GetAccessDutytListDutiesbyId: (data: IAccessDutyListModel): Promise<IAccessDutyListModel> => client.get(`${ApiPath}/${data.Id}`),
  GetAccessDutytListDutiesbyRolId: (Id: any): Promise<IAccessDutyListModel[]> => client.get(`${ApiPath}/GetByRolId/${Id}`),
  PostAccessDutytListDuties: (data: IAccessDutyListModel[]): Promise<any> => client.post(`${ApiPath}`, data),
  DeleteAccessDutytListDuties: (Id: any): Promise<any> => client.delete(`${ApiPath}/${Id}`),
};